import type { JSX } from 'react'
export default function InselhuepfenIcon ({ className, size = 1 }: { className?: string, size?: number }): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg' version='1.1'
      viewBox='0 0 21.7 19.5'
      width={22 * size} height={20 * size}
      className={className}
    >
      <g>
        <path
          fill='currentColor'
          d='M19.1,19.3c0,0-.1,0-.2,0-.2-.1-.3-.4-.2-.6,0,0,.7-1.3.7-1.3l.4-.9s0-.1,0-.1c0,0-.1,0-.1,0H1.9s-.1,0-.2,0c0,0,0,.1,0,.1l1.3,2.2c0,.3,0,.5-.3.6-.2,0-.4,0-.5-.2l-1.3-2.2c-.2-.3-.2-.7,0-1.1.2-.3.6-.5,1-.5h17.6c.4,0,.8.2,1,.5.2.3.2.7,0,1.1l-1.1,2.2c0,.2-.3.3-.5.2Z'
        />
        <path
          fill='currentColor'
          d='M11.1,15c-.4,0-.7-.2-1-.4-.3-.3-.4-.6-.4-1V1.3c0-.6.3-.8.5-.9s.6,0,.9.5l7.5,12.5c.3.5.2,1.1-.3,1.4-.2.1-.4.2-.6.2h-6.6ZM10.6,2.1v11.4h0c0,.3.2.5.5.5h6.7s0,0,0,0L10.6,2.1Z'
        />
        <path
          fill='currentColor'
          d='M7.9,15h-3.9c-.4,0-.8-.2-1-.5-.2-.3-.2-.8,0-1.1L7.9,5.3c.3-.5.7-.6.9-.5s.5.3.5.9v7.8c0,.8-.6,1.4-1.4,1.4ZM3.9,14h4c.3,0,.5-.2.5-.5,0,0,0,0,0,0v-7.1l-4.5,7.5s0,0,0,0h0ZM9.3,5.7h0Z'
        />
      </g>
    </svg>

  )
}

export function InselhuepfenPhone (): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={24} height={24}>
      <g>
        <path
          className='fill-current'
          d='M17.2,22.25c-2.46,0-5.46-1.89-9.43-5.94S1.92,9.09,2,6.56a6.19,6.19,0,0,1,2.38-4.4,1.5,1.5,0,0,1,2.11,0l3.73,3.85a1.51,1.51,0,0,1,0,2.14L8.22,10c-.05.4,1.37,2.51,3.48,4.36a5.16,5.16,0,0,0,2.35,1.47c.27-.25,1.3-1.25,1.85-1.79a1.51,1.51,0,0,1,2.11,0h0l3.59,3.66a1.49,1.49,0,0,1,0,2.09c-1.15,1.22-2.43,2.41-4.38,2.43ZM5.37,2.75A.48.48,0,0,0,5,2.88,5.3,5.3,0,0,0,3,6.58c0,2.25,1.77,5.2,5.52,9s6.58,5.64,8.72,5.64h0c1.55,0,2.62-1,3.67-2.12a.49.49,0,0,0,0-.69L17.3,14.77a.5.5,0,0,0-.7,0,24.06,24.06,0,0,1-2.06,2c-1.56.79-5.11-3-6.16-4.47S7,9.85,7.51,9.31L9.44,7.47a.48.48,0,0,0,.16-.35.43.43,0,0,0-.14-.36L5.73,2.9A.51.51,0,0,0,5.37,2.75Z'
        />
      </g>
    </svg>
  )
}

export function InselhuepfenSendMessage (): JSX.Element {
  return (
    <svg id='Ebene_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 494.92 389.27' width={24} height={24}>
      <path
        className='fill-current stroke-0' fillRule='evenodd'
        d='M442.81,321.6v8.13c-1.62,9.96-13.25,10.33-26.01,9.75-32.22-1.46-59.9-5.74-90.22-13.82-55.67-14.82-127.32-14.89-183.7,0-30.06,7.94-57.21,12.4-89.41,13.82-6.16.27-12.96,1.25-18.91-.88-6.36-2.27-9.39-10.14-8.11-16.58,1.44-7.24,9.81-8.19,14.82-11.81,6.9-4.98,14.49-14.49,21.95-21.95,37.26-37.26,72.36-72.36,109.73-109.73,14.82-14.82,31.91-29.45,56.09-31.7,15.81-1.47,24.33.97,34.95,3.25,21.88-18.76,44.1-44.23,66.65-65.03-12.41-7.84-13.4-31.48,4.88-30.89,9.77.32,12.21,10.98,17.88,9.75,8.11-14.32,3.67-34.48,21.95-34.14,11.23.21,25.41,19.72,34.14,28.45,9.89,9.89,28.15,22.18,27.64,34.95-.68,16.88-22.19,13.71-34.95,21.13,2.86,6.85,11.46,7.87,10.57,19.51-.65,8.46-6.76,13.01-13.82,13.01s-12.86-10.71-16.26-10.57c-2.52.11-12.32,13.13-16.26,17.07-18.18,18.18-34.18,32.32-49.58,50.4,12.64,30.8-4.06,64.04-17.88,80.47-1.2,1.43-4.6,3.38-3.25,5.69,30.88,6.01,64.02,17.41,99.98,20.32,17.89,1.45,42.77-2.06,47.14,11.38ZM375.34,89.13c1.89.55,2.18,2.7,4.06,3.25,5.18-2.41,10.87-4.3,17.07-5.69-4-6.56-10.09-11.05-15.44-16.26-1.58,6.55-4.45,11.81-5.69,18.7ZM292.43,220.81c-.74-6.61-7.38-15.51-6.5-23.57.82-7.54,12.21-15.46,17.88-21.13,14.51-14.51,25.73-25.73,39.83-39.83,4.35-4.35,19.63-17.55,19.51-20.32-.16-3.65-10.23-7.1-12.19-11.38-18.06,16.87-39.4,39.4-59.34,59.34-6,6-14.84,16.28-21.13,17.07-5.97.75-9.93-2.47-15.44-4.06-30.34-8.79-47.49,6.85-64.21,23.57-35.17,35.17-66.93,66.11-100.79,99.98-2.84,2.84-7.73,6.76-6.5,8.94,7.06-2.15,18.12-.38,26.01-4.06,8.61-4.02,19.32-19.32,27.64-27.64,20.11-20.11,35.1-35.1,55.27-55.27,7.53-7.53,20.43-24.65,30.89-24.38,10.89.28,19.15,14.28,26.01,21.13,6.73,6.73,20.98,15.08,19.51,27.64-1,8.5-12.34,15.59-17.07,20.32-3.2,3.2-5.72,6.53-8.94,9.75-3.07,3.07-8.86,6.16-7.32,8.94h21.95c17.57-17.44,38.69-31.58,34.95-65.03ZM222.53,232.19c-16.46,16.76-35.79,36.6-52.02,52.83-1.6,1.6-5.99,3.3-4.88,6.5,9.36-3.54,18.58-.85,26.01-4.06,7.78-3.37,14.87-14.87,21.13-21.13,7.78-7.78,15.06-14.54,21.95-21.13-2.92-5.48-7.92-8.88-12.19-13Z'
      />
    </svg>
  )
}

export function InselhuepfenFAQ (): JSX.Element {
  return (
    <svg id='Ebene_1' xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 25.5 25.5' width={24} height={24}>
      <g id='Ebene_2'>
        <path
          className='fill-current stroke-0'
          d='M12.7,24.6C6.2,24.6.9,19.4.8,12.8S6,1,12.6,1s11.8,5.2,11.9,11.8h0c0,2-.2,3.1-1,5s2.1,5.7,1.5,6.3-5-2-5.8-1.5c-1.9,1.3-4,2-6.5,2h0ZM12.7,2C6.7,2,1.9,6.8,1.8,12.8c0,6,4.8,10.8,10.8,10.9,6,0,10.8-4.8,10.9-10.8h0c0-6-4.8-10.9-10.8-10.9h0Z'
        />
        <path
          className='fill-current stroke-0'
          d='M11.3,13.6c.2-.4.5-.8,1.1-1.3l1-.7c.5-.3.8-.7,1-1.1.2-.4.3-.8.3-1.4s-.2-1.1-.5-1.5c-.4-.4-.8-.6-1.4-.6s-1.4.2-1.8.7c-.4.4-.7,1.1-.7,2h-2.5c0-1.5.4-2.7,1.3-3.5.9-.8,2.1-1.3,3.7-1.3s2.5.4,3.2,1.1c.8.8,1.2,1.7,1.2,3s-.2,1.6-.6,2.2c-.4.6-.9,1.2-1.7,1.8l-.8.6c-.4.3-.6.5-.7.8-.1.2-.2.5-.2.9v.3h-2.1s0-1.6.2-2ZM11,20c-.3-.4-.5-.8-.5-1.3s.2-.9.5-1.3c.3-.3.8-.5,1.3-.5s.9.2,1.3.5c.4.3.5.8.5,1.3s-.2.9-.5,1.3c-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5Z'
        />
      </g>
    </svg>
  )
}
